import type { FaireProductEntity } from "../../entity_types/product";

export const p_mpud6tczqj: FaireProductEntity = {
  token: "p_mpud6tczqj",
  type: "product",
  name: "Conditioner Bar | Peppermint + Eucalyptus | Travel Container",
  brandToken: "b_7epwzqn7do",
  brandName: "Zero Waste MVMT",
  imageUrl:
    "https://cdn.faire.com/fastly/7aa9fe4778d3aecad6accd6e7767bad6b08c2a9ba888b3ac04b12161097f8b82.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3a1bcbae338edd9b0842c615a4958876c91982c348ba3bd5c53a74e11cf8dde2.png",
    "https://cdn.faire.com/fastly/546ddc36842f877fa75f421e3718fb7affe14f146deb1dd65c1231e2fa879a08.jpeg",
    "https://cdn.faire.com/fastly/db8f9d7681d9ecf2277ea2cf89ce97ccac6de55954893858412ececa27b54544.jpeg",
    "https://cdn.faire.com/fastly/44ba45499ab63c6a6e7e9cd1b886e5e2ca7baffc9e78fe1bc6460a831dc50c8e.jpeg",
    "https://cdn.faire.com/fastly/605322bafaeab7be809ff07b34f31a61acdac9dcec96e7889286cbc767e7b932.jpeg",
    "https://cdn.faire.com/fastly/51178d8477c3e5742e0250442abfe958c74601725b8136d234712129969cdba0.jpeg",
    "https://cdn.faire.com/fastly/0918faf5b197fad8f140392e39b6cc7ec745e037c10ec577a9a6c8a91e19f33a.jpeg",
    "https://cdn.faire.com/fastly/ee803045260c3b3f7f06e6878ef3280d9d2a5c210e655515fa5aa2237e20be6f.jpeg",
    "https://cdn.faire.com/fastly/80c5140e0734d1b420cc4f8048c7ecb50dd7813733a36c48c6ddff184c695de7.jpeg",
  ],
  priceDollars: 9.75,
  description:
    "Our Peppermint + Eucalyptus Conditioner Bar is designed for those seeking deep nourishment, detangling, and an invigorating, refreshing scent—without any plastic waste. This bar combines the crisp, cooling aroma of peppermint with the herbal, uplifting essence of eucalyptus, creating a revitalizing fragrance that awakens the senses and soothes the scalp.\n\nEnriched with hydrating cocoa butter, coconut oil, and jojoba oil, it smooths frizz, locks in moisture, and leaves hair soft, shiny, and easy to manage. Perfect for eco-conscious individuals, this conditioner bar transforms your hair care routine into a refreshing, zero-waste experience that benefits both your hair and the planet.\n\nPlastic-Free: Replaces 3 plastic bottles with every bar.\n\n100% Compostable Packaging: No waste left behind.\n\nABOUT ZERO WASTE MVMT\n\nZero Waste MVMT is an eco-conscious brand on a mission to help you live more sustainably with plastic-free reusables and natural, earth-friendly products 🌱",
  tags: [],
  msrpDollars: 19.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:18.376Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
